/**
 * "For your information": the rows a queue holds that the account cannot act on (Wave
 * Experience A, item 3; Mahmoud's doctrine "a queue lists only rows the account can act
 * on"). Collapsed by default, counted in its summary, quiet in tone.
 *
 * Author: Mahmoud Ragab Ahmed.
 */

import { strings } from "../brand/strings";

export function FyiBlock({
  count,
  testId = "fyi-block",
  children,
}: {
  readonly count: number;
  readonly testId?: string;
  readonly children: React.ReactNode;
}): React.JSX.Element | null {
  if (count === 0) {
    return null;
  }
  return (
    <details
      className="q-ui rounded-md border border-rule"
      style={{ padding: "var(--q-s-1) var(--q-s0)", marginTop: "var(--q-s-1)" }}
      data-testid={testId}
    >
      <summary
        className="cursor-pointer text-sm text-muted-foreground"
        data-testid={`${testId}-summary`}
      >
        {strings.fyi.summary(count)}
      </summary>
      <div className="mt-2 flex flex-col gap-2">{children}</div>
    </details>
  );
}
